{
  "name": "entscheidungsnavi",
  "version": "9.0.2",
  "license": "ISC",
  "private": true,
  "engines": {
    "node": ">=22.23.4",
    "pnpm": ">=11.3.0"
  },
  "web-types": "./web-types.json",
  "scripts": {
    "i18n": "nx extract-i18n",
    "ng": "nx",
    "postinstall": "pnpm run supported-browsers",
    "nx": "nx",
    "start": "nx serve",
    "start:en": "pnpm run start -- --configuration en",
    "supported-browsers": "node tools/supported-browsers.mjs",
    "test": "nx run-many --all --target=test --parallel",
    "lint": "nx run-many --all --target=lint",
    "e2e": "nx run-many --all --target=e2e",
    "affected:apps": "nx affected:apps",
    "affected:libs": "nx affected:libs",
    "affected:build": "nx affected:build",
    "affected:e2e": "nx affected:e2e",
    "affected:test": "nx affected:test",
    "affected:lint": "nx affected:lint",
    "affected:dep-graph": "nx affected:dep-graph",
    "affected": "nx affected",
    "format": "nx format:write",
    "format:write": "nx format:write",
    "format:check": "nx format:check",
    "update": "nx migrate latest",
    "dep-graph": "nx dep-graph",
    "help": "nx help",
    "workspace-generator": "nx workspace-generator",
    "prepare": "husky install"
  },
  "dependencies": {
    "@ai-sdk/openai": "^3.0.41",
    "@angular/animations": "20.3.12",
    "@angular/cdk": "20.2.13",
    "@angular/common": "20.3.12",
    "@angular/compiler": "20.3.12",
    "@angular/core": "20.3.12",
    "@angular/forms": "20.3.12",
    "@angular/localize": "20.3.12",
    "@angular/material": "20.2.13",
    "@angular/platform-browser": "20.3.12",
    "@angular/platform-browser-dynamic": "20.3.12",
    "@angular/router": "20.3.12",
    "@angular/service-worker": "20.3.12",
    "@fontsource/roboto": "^5.0.8",
    "@fontsource/roboto-mono": "^5.0.8",
    "@nestjs/axios": "^3.0.2",
    "@nestjs/common": "10.2.10",
    "@nestjs/config": "3.1.1",
    "@nestjs/core": "10.2.10",
    "@nestjs/mapped-types": "2.0.4",
    "@nestjs/mongoose": "10.0.2",
    "@nestjs/passport": "10.0.3",
    "@nestjs/platform-express": "10.2.10",
    "@nestjs/schedule": "^6.1.0",
    "@nestjs/throttler": "5.1.1",
    "@schematics/angular": "20.3.9",
    "@sentry/angular": "^10.38.0",
    "@sentry/cli": "^3.1.0",
    "@sentry/nestjs": "^10.38.0",
    "@swimlane/ngx-charts": "23.1.0",
    "ai": "6.0.116",
    "angulartics2": "^12.2.1",
    "body-parser": "^1.20.2",
    "class-transformer": "^0.5.1",
    "class-validator": "^0.14.1",
    "connect-mongo": "^5.1.0",
    "core-js": "^3.36.0",
    "csrf-sync": "^4.0.3",
    "d3-interpolate-path": "^2.3.0",
    "diff-match-patch": "^1.0.5",
    "escape-string-regexp": "^5.0.0",
    "exceljs": "^4.4.0",
    "express-session": "^1.18.0",
    "file-saver": "^2.0.5",
    "handlebars": "^4.7.8",
    "helmet": "^7.1.0",
    "html-to-image": "^1.11.11",
    "joi": "^17.12.2",
    "jszip": "^3.10.1",
    "katex": "^0.16.9",
    "lodash": "^4.17.21",
    "mailpit-api": "^1.6.0",
    "material-symbols": "^0.16.0",
    "mathjs": "^12.4.0",
    "mongoose": "^8.12.0",
    "ngx-color": "^9.0.0",
    "ngx-quill": "^24.0.5",
    "nodemailer": "7.0.11",
    "nodemailer-express-handlebars": "^7.0.0",
    "openai": "^6.10.0",
    "passport": "^0.7.0",
    "passport-local": "^1.0.0",
    "passport-local-mongoose": "^8.0.0",
    "pdfmake": "^0.2.9",
    "quill": "^1.3.7",
    "quill-blot-formatter": "~1.0.5",
    "quill-delta": "^5.1.0",
    "reflect-metadata": "^0.1.14",
    "ress": "^5.0.2",
    "rxjs": "~7.8.1",
    "sanitize-filename": "^1.6.3",
    "semver": "^7.6.0",
    "tslib": "^2.6.2",
    "uuid": "^9.0.1",
    "zod": "^4.1.12",
    "zone.js": "0.15.0",
    "zxcvbn": "^4.4.2"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "20.3.9",
    "@angular-devkit/core": "20.3.9",
    "@angular-devkit/schematics": "20.3.9",
    "@angular/cli": "~20.3.0",
    "@angular/compiler-cli": "20.3.12",
    "@angular/language-service": "20.3.12",
    "@eslint/js": "9.36.0",
    "@nestjs/schematics": "11.0.9",
    "@nestjs/testing": "10.2.10",
    "@nx-tools/container-metadata": "7.0.2",
    "@nx-tools/nx-container": "7.0.2",
    "@nx/angular": "22.0.4",
    "@nx/devkit": "22.0.4",
    "@nx/esbuild": "22.0.4",
    "@nx/eslint": "22.0.4",
    "@nx/eslint-plugin": "22.0.4",
    "@nx/jest": "22.0.4",
    "@nx/js": "22.0.4",
    "@nx/nest": "22.0.4",
    "@nx/node": "22.0.4",
    "@nx/playwright": "22.0.4",
    "@nx/workspace": "22.0.4",
    "@percy/cli": "^1.28.0",
    "@percy/playwright": "^1.0.8",
    "@playwright/test": "1.61.1",
    "@types/d3-interpolate-path": "^2.0.3",
    "@types/d3-scale": "^4.0.8",
    "@types/d3-selection": "^3.0.10",
    "@types/d3-shape": "^3.1.6",
    "@types/d3-transition": "^3.0.8",
    "@types/diff-match-patch": "^1.0.36",
    "@types/express": "4.17.21",
    "@types/express-session": "^1.17.10",
    "@types/file-saver": "^2.0.7",
    "@types/jest": "29.5.14",
    "@types/katex": "^0.16.7",
    "@types/lodash": "^4.14.202",
    "@types/node": "22.16.0",
    "@types/nodemailer": "^6.4.14",
    "@types/nodemailer-express-handlebars": "^4.0.6",
    "@types/passport-local": "^1.0.38",
    "@types/passport-local-mongoose": "^6.1.5",
    "@types/pdfmake": "^0.2.9",
    "@types/quill": "^2.0.14",
    "@types/resize-observer-browser": "^0.1.11",
    "@types/semver": "^7.5.8",
    "@types/supertest": "^2.0.16",
    "@types/uuid": "^9.0.8",
    "@types/zxcvbn": "^4.4.4",
    "@typescript-eslint/utils": "^8.29.0",
    "angular-eslint": "20.6.0",
    "browserslist-useragent-regexp": "^4.1.1",
    "dotenv": "16.3.1",
    "eslint": "9.36.0",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-playwright": "^1.6.2",
    "express-http-proxy": "^2.1.1",
    "husky": "^8.0.3",
    "jest": "29.7.0",
    "jest-environment-jsdom": "29.7.0",
    "jest-preset-angular": "14.6.2",
    "lint-staged": "^17.0.8",
    "mongodb-memory-server": "^10.1.2",
    "nx": "22.0.4",
    "prettier": "3.3.3",
    "start-server-and-test": "2.0.8",
    "supertest": "^6.3.4",
    "ts-jest": "29.4.5",
    "ts-node": "10.9.2",
    "typescript": "5.9.3",
    "typescript-eslint": "^8.29.0"
  },
  "overrides": {
    "ngx-quill": {
      "@angular/core": "19.1.8"
    },
    "jest-environment-jsdom": {
      "jsdom": "25.0.1",
      "rrweb-cssom": "0.8.0"
    }
  },
  "packageManager": "pnpm@11.3.0+sha512.2c403d6594527287672b1f7056343a1f7c3634036a67ffabfcc2b3d7595d843768f8787148d1b57cf7956c90606bbd192857c363af19e96d2d0ec9ec5741d215"
}
